<div class="card-header" i18n>Select Attachments</div>
<div class="card-body">
  <div *ngFor="let doc of dealerDocuments">
    <mat-checkbox id="{{doc.dealerDocument_ID}}" name="doc_{{doc.dealerDocument_ID}}" [(NgModel)]="doc.isSelected"
                  [disabled]="readOnlyRole && readOnlyRole != doc.dealerDocument_ID" (change)="selectionChanged(doc)">
      {{doc.document_FileName}}
    </mat-checkbox>
  </div>
</div>
